import React from 'react';

import { Button } from '@alfalab/core-components/button';
import { Gap } from '@alfalab/core-components/gap';
import { Modal } from '@alfalab/core-components/modal';
import { Typography } from '@alfalab/core-components/typography';

import { PasswordInstruction } from '../password-instruction/password-instruction';

export const PasswordRecoveryModal = () => {
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <React.Fragment>
            <Button view='link' size='m' block={true} type='button' onClick={handleOpen}>
                Забыли пароль?
            </Button>

            <Modal open={open} onClose={handleClose}>
                <Modal.Header sticky={true} hasCloser={true} title='Как получить новый пароль' />
                <Modal.Content flex={true}>
                    <PasswordInstruction />
                    <Gap size='m' />
                    <Typography.Text>
                        Если проблема не в пароле — всё равно свяжитесь с HelpDesk
                    </Typography.Text>
                </Modal.Content>
            </Modal>
        </React.Fragment>
    );
};
